import { Button, useStyles, useTheme } from '@archipro-design/aria';
import { useDesignBoardPageState } from '../../context';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';
import { PencilLine } from '@archipro-design/icons';
import * as S from '~/modules/design-board/component/board-detail/BoardDetailFilter.style';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';
import { useTracker } from '@archipro-website/tracker';

interface EditButtonProps {
    board: DesignBoardWithDetailedPinsFragment;
}

const EditButton = ({ board }: EditButtonProps) => {
    const { dispatch } = useDesignBoardPageState();
    const { css } = useStyles();
    const theme = useTheme();
    const tracker = useTracker();

    const onEditBoard = () => {
        dispatch({
            type: 'OpenEditDrawer',
            designBoardInput: {
                title: board.Title,
                description: board.Content !== null ? board.Content : undefined,
                isPrivate: !board.Public,
                id: board.ID,
            },
        });
        tracker.log('EditBoardReveal', {
            url: new URL(window.location.href),
            data: {
                ElementID: 'designboard_detail_header_editBoardReveal',
                Source: 'designBoard, detail, header',
            },
        });
    };

    const darkOutlinedButtonBorderNormal = `1px solid ${theme.siteVariables.colors.charcoal[250]}`;

    return (
        <BoardActionWithLoginPrompt
            action={
                <Button
                    color="dark"
                    iconBefore={<PencilLine />}
                    size={24}
                    variables={{
                        buttonPadding: 16,
                        iconPadding: 4,
                        darkOutlinedButtonBorderNormal,
                    }}
                    variant="outlined"
                    onClick={onEditBoard}
                    className={css(S.EditButton)}
                >
                    EDIT
                </Button>
            }
        />
    );
};

export default EditButton;
